export default __webpack_public_path__ + "static/media/flag-button-highlight@3x.1d6f0f84.png";